import React, { useEffect, useState } from 'react';
import { useTheme } from '../ThemeContext';
import { AGENT_MOBILE_TABS } from '../shared/mobileTabs';
import Dashboard from './Dashboard';
import { AgentPastDueNotice } from './AgentPastDueNotice';

const DAY = 24 * 60 * 60 * 1000;

function ago(days) {
  return new Date(Date.now() - days * DAY).toISOString();
}

function clicks(type, count, vendorName, vendorId, daysAgo) {
  const rows = [];
  for (let i = 0; i < count; i += 1) {
    rows.push({
      click_type: type,
      clicked_at: ago(daysAgo),
      vendor_id: vendorId,
      vendor_name: vendorName,
    });
  }
  return rows;
}

function previewActivity() {
  const tasks = [];
  for (let i = 0; i < 8; i += 1) tasks.push({ completed: true, completed_at: ago(2 + i), client_id: 'c1', client_name: 'Maya Chen' });
  for (let i = 0; i < 5; i += 1) tasks.push({ completed: true, completed_at: ago(3 + i), client_id: 'c2', client_name: 'Luis Ortega' });
  for (let i = 0; i < 3; i += 1) tasks.push({ completed: true, completed_at: ago(4), client_id: 'c3', client_name: 'Priya Shah' });
  return {
    clicks: clicks('phone', 18, 'Harbor Plumbing', 'v1', 4)
      .concat(clicks('email', 11, 'Oak Street Electric', 'v2', 6))
      .concat(clicks('website', 7, 'Palm Roofing', 'v3', 8))
      .concat(clicks('phone', 4, 'Harbor Plumbing', 'v1', 40)),
    clients: [
      { id: 'c1', first_name: 'Maya', last_name: 'Chen', status: 'active', agent_id: 'preview', last_active: ago(1), created_at: ago(12) },
      { id: 'c2', first_name: 'Luis', last_name: 'Ortega', status: 'active', agent_id: 'preview', last_active: ago(3), created_at: ago(40) },
      { id: 'c3', first_name: 'Priya', last_name: 'Shah', status: 'active', agent_id: 'preview', last_active: ago(6), created_at: ago(20) },
    ],
    tasks,
    projects: [
      { tasks: [{ completed: true }, { completed: true }], updated_at: ago(5) },
      { tasks: [{ completed: true }], updated_at: ago(9) },
    ],
    reports: [{ created_at: ago(7) }, { created_at: ago(11) }],
    shares: [{ shared_at: ago(8) }],
    transfers: [{ claimed_at: ago(15) }],
  };
}

const NAV = ['Dashboard', 'My Profile', 'Clients', 'Vendors', 'Tasks', 'Projects', 'Assistant', 'Pacarion Home History Report', 'More'];

function AgentHomePreview() {
  const { colors, isDark } = useTheme();
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < 768);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  const params = new URLSearchParams(window.location.search);
  const pastDue = params.get('past_due') === '1';
  const billing = params.get('billing') === '1';
  const profile = {
    id: 'preview',
    first_name: 'Alex',
    last_name: 'Rivera',
    subscription_plan: 'solo',
    subscription_status: pastDue ? 'past_due' : 'active',
    stripe_customer_id: 'cus_preview',
    phone: '',
  };
  const src = isDark
    ? `${process.env.PUBLIC_URL}/images/logo/pacarion-logo-dark.png`
    : `${process.env.PUBLIC_URL}/images/logo/pacarion-logo-light.png`;
  return (
    <div style={{ minHeight: '100vh', background: colors.background, color: colors.text, display: 'flex', flexDirection: 'column' }}>
      <header style={{
        background: colors.surface,
        borderBottom: '1px solid ' + colors.border,
        display: 'flex',
        alignItems: 'center',
        justifyContent: isMobile ? 'center' : 'flex-start',
        padding: isMobile ? '6px 16px' : '1.15rem 2rem',
        minHeight: isMobile ? '44px' : 'auto',
      }}
      >
        <img className="top-bar-wordmark" src={src} alt="Pacarion" style={{ height: isMobile ? '33px' : '40px', width: 'auto' }} />
      </header>
      <div style={{ display: 'flex', flex: '1 1 auto', minWidth: 0 }}>
        {!isMobile && (
          <nav aria-label="Agent" style={{ width: '250px', flex: '0 0 250px', background: colors.surface, borderRight: '1px solid ' + colors.border, padding: '1.25rem 0' }}>
            {NAV.map((label) => {
              const active = billing ? label === 'More' : label === 'Dashboard';
              return (
                <div key={label} style={{ padding: '0.85rem 1.5rem', fontSize: '0.9rem', color: active ? colors.primary : colors.textSecondary, borderLeft: '2px solid ' + (active ? colors.primary : 'transparent') }}>{label}</div>
              );
            })}
          </nav>
        )}
        <main style={{ flex: '1 1 auto', minWidth: 0, padding: isMobile ? '1rem 1rem 5.5rem' : '2rem 2.5rem' }}>
          {billing ? (
            <div>
              <h4 style={{ margin: '0 0 1rem', color: colors.text, fontSize: '1.15rem' }}>Subscription & Billing</h4>
              <AgentPastDueNotice
                profile={profile}
                colors={colors}
                isDark={isDark}
                onUpdateCard={() => {}}
              />
            </div>
          ) : (
          <Dashboard
            profile={profile}
            stats={{ activeUsers: 3, totalVendors: 3 }}
            onNavigate={() => {}}
            activityOverride={previewActivity()}
          />
          )}
        </main>
      </div>
      {isMobile && (
        <nav aria-label="Agent tabs" style={{ position: 'sticky', bottom: 0, display: 'flex', background: colors.surface, borderTop: '1px solid ' + colors.border }}>
          {AGENT_MOBILE_TABS.map((tab) => (
            <div key={tab.id} style={{ flex: '1 1 0', textAlign: 'center', padding: '0.7rem 0.15rem', fontSize: '13px', fontWeight: (billing ? tab.id === 'settings' : tab.id === 'dashboard') ? 600 : 400, color: (billing ? tab.id === 'settings' : tab.id === 'dashboard') ? colors.primary : colors.textSecondary }}>{tab.label}</div>
          ))}
        </nav>
      )}
    </div>
  );
}

export default AgentHomePreview;
